export default "__VITE_ASSET__6oqIwrfi__"